﻿import ko from 'knockout';
import $ from 'jquery'

declare global {
  interface KnockoutStatic {
    dependentObservable: any;
  }
}

export default class NullableNumericObservable {
  constructor(initialValue?: any) {
    var rawValue = ko.observable(initialValue);
    var formatted = ko.dependentObservable({
      read: () => {
        var v = rawValue();
        if ((isNaN(v) || !v) && v !== 0)
          return null;
        return "" + v;
      },
      write: (val) => {
        if ((isNaN(val) || !val) && val !== 0)
          rawValue(null);
        else rawValue(val);
      }
    });
    return formatted;
  }
}
